<template>
    <div>
        <div class="innerMainContent">

            <PageHeader icon="i_calender" :title="$t('tableAdd')" :breadcrumbs="[
                { name: $t('menu_settings'), route: '/settings' },
                { name: $t('tables'), route: '/settings/tables' },
                { name: $t('tableAdd'), route: null },
            ]">
                <template v-slot:action-buttons>
                    <!-- <router-link tag="button" class="s_btn" :to="'/pdf/event/'+eventID">צור PDF</router-link> -->
                </template>
            </PageHeader>



            <div class="innerBox">
                <form action="" id="editBanner" class="formWrap" @submit.prevent="submitForm">
                    <div class="row">
                        <div class="col-xs-12 containerWidth">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="name">*{{ $t('table_name') }}</label>
                                        <input type="text" id="name" name="name" v-model="table.title" required>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="target">*{{ $t('shape') }}</label>
                                        <div class="selectWrap">
                                            <select name="target" id="target" v-model="table.shape" required>
                                                <option v-for="shape in $t('shapes')" v-bind:value="shape.id" v-bind:selected="shape.id == 'all'">{{ shape.title }}</option>
                                            </select>
                                            <svg class="i_select">
                                                <use xlink:href="#i_select"></use>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="name">*{{ $t('capacity') }}</label>
                                        <input type="number" id="capacity" name="capacity" v-model="table.capacity" required>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="table.shape !== 'ellipseTable' && table.shape !== 'circleTable'">
                                <div class="col-sm-3">
                                    <div class="inputWrap">
                                        <label for="tableSide1">{{ $t('side1') }} {{ $t('optional') }}</label>
                                        <input type="number" id="tableSide1" name="tableSide1" v-model="table.side1">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="inputWrap">
                                        <label for="tableSide2">{{ $t('side2') }} {{ $t('optional') }}</label>
                                        <input type="number" id="tableSide2" name="tableSide2" v-model="table.side2">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="inputWrap">
                                        <label for="tableSide3">{{ $t('side3') }} {{ $t('optional') }}</label>
                                        <input type="number" id="tableSide3" name="tableSide3" v-model="table.side3">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="inputWrap">
                                        <label for="tableSide4">{{ $t('side4') }} {{ $t('optional') }}</label>
                                        <input type="number" id="tableSide4" name="tableSide4" v-model="table.side4">
                                    </div>
                                </div>


                            </div>
                            <FormInput v-model="table.maxReserve" label="כמות רזרבה מקסימלית"></FormInput>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap submitWrap my-3">
                                        <button class="submit">{{ $t('save') }}</button>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AddTable',
    data() {
        return {
            table: {
                title: '',
                shape: 'SQU',
                capacity: '',
                side1: null,
                side2: null,
                side3: null,
                side4: null,
                maxReserve: 2,
            },
        }
    },
    components: {
    },
    beforeMount() {

    },
    methods: {
        submitForm() {
            this.$store.dispatch('addTable', this.$data.table)
                .then(response => {
                  this.AlertSuccess()
                })
                .catch(response => {
                    let err = this.$t('fatalError');

                   this.AlertError()
                })
        }
    }
}

</script>
<style scoped>


.editEventActions {
    float: left;
    margin-top: 6px;
}

.editEventActions .backBtn span {
    color: #7c97c5;
    font-weight: 700;
    font-size: 1.235rem;
    display: inline-block;
    vertical-align: middle;
}

.editEventActions .backBtn svg {
    display: inline-block;
    vertical-align: middle;
    width: 26px;
    height: 18px;
    fill: #293b5a;
    margin-right: 5px;
}

.editEventActions .deleteBtn {
    width: 218px;
    height: 54px;
    background: #fff;
    border: 1px solid #d4d4d4;
    border-radius: 27px;
    margin-left: 30px;

}

.editEventActions .deleteBtn span {
    color: #293b5a;
    font-weight: 700;
    font-size: 1rem;
    display: inline-block;
    vertical-align: middle;
}

.editEventActions .deleteBtn svg {
    display: inline-block;
    vertical-align: middle;
    width: 19px;
    height: 23px;
    fill: #849dc8;
    margin-left: 10px;
}

.innerBox {
    padding: 30px;
}

.h1Wrap svg.i_profile {
    width: 26px;
    height: 30px;
}
</style>
